/**
 * BE#891: when a workspace has used more than its allowance (+ top-ups), the backend reports the excess as
 * `creditsOverage` and keeps `totalCredits` at the real allowance. Older backends omit the field → 0.
 */
export function getCreditOverage(data: { creditsOverage?: number } | null | undefined): number {
  const n = data?.creditsOverage;
  return typeof n === 'number' && Number.isFinite(n) && n > 0 ? Math.ceil(n) : 0;
}
